import Vue from 'vue';
import { formatMoney } from 'accounting';

function currencyFilter(value, symbol = '£', precision = 0) {
  return formatMoney(value, { symbol, precision });
}

function roundToNearestHundred(value) {
  return Math.round(value / 100) * 100;
}

Vue.filter('currency', currencyFilter);
Vue.filter('roundToNearestHundred', roundToNearestHundred);